export class ReadExportQuery {
  template_id: any;
  startDate: any;
  endDate: any;
  orgId: any;

  constructor(
    template_id: any,
    startDate: any,
    endDate: any,
    orgId: any
  ) {
    this.template_id = template_id;
    this.startDate = startDate;
    this.endDate = endDate;
    this.orgId = orgId;
  }

  public static createQueryURL(query) {
    let queryParams = '?';
    for (let q in query) {
      if (query[q]) {
        queryParams += q + '=' + query[q] + '&';
      }
    }
    return queryParams;
  }
}
